import { getObjectUtil } from 'packages/src'
import { REDUX_STATUS } from '../../constants'

function isSavingReduxSelector (path) {
  return state => getObjectUtil(state, `${path}.status`) === REDUX_STATUS.SAVING
}

export default isSavingReduxSelector
